const scriptLoader = (url, opts = {}) => new Promise((resolve, reject) => {
    const script = document.createElement('script');

    Object.keys(opts).forEach(key => {
        script.setAttribute(key, opts[key]);
    })

    script.type = 'text/javascript';

    script.async = 1;

    script.onload = resolve;

    script.onerror = reject;

    script.src = url;

    document.body.appendChild(script)
});

export default scriptLoader;